import { asyncActionsCreator, createActionRedux } from '../../global/redux';
import * as constants from './constants';

export const getCurrentReceipt = asyncActionsCreator(
  constants.GET_CURRENT_RECEIPT
);

export const setChosenReceipt = asyncActionsCreator(
  constants.SET_CHOSEN_RECEIPT
);

export const getClientInfo = asyncActionsCreator(constants.GET_CLIENT_INFO);

export const applyBonuses = asyncActionsCreator(constants.APPLY_BONUSES);
export const submitLoyaltyOrder = asyncActionsCreator(
  constants.SUBMIT_LOYALTY_ORDER
);

export const resetClientInfo = createActionRedux(constants.RESET_CLIENT_INFO);
export const resetCurrentReceipt = createActionRedux(
  constants.RESET_CURRENT_RECEIPT
);
export const resetApplyBonuses = createActionRedux(
  constants.RESET_APPLY_BONUSES
);
export const resetSubmitOrder = createActionRedux(constants.RESET_SUBMIT_ORDER);

export const generateLoyaltyReport = asyncActionsCreator(
  constants.GENERATE_LOYALTY_REPORT
);
